module.exports = __webpack_public_path__ + "img/80.1.bb58a5f9.jpg";